import CloseMenuIcon from './closeMenu.svg';
import LogoTabletIcon from './logoTablet.svg';
import MenuIcon from './menu.svg';

export { CloseMenuIcon, LogoTabletIcon, MenuIcon };
